import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import AnalyticsService from 'cio/services/analytics';
import ObjectTypeModel from 'cio/models/object-type';

enum Guidetab {
  TrackAPI = 'track',
  ReverseETL = 'reverse',
}

export default class ObjectsTypeGuideController extends Controller {
  @service analytics!: AnalyticsService;

  readonly guideTab = Guidetab;
  @tracked activeTab = this.guideTab.TrackAPI;

  declare model: ObjectTypeModel;

  get currentURL() {
    return window.location.href;
  }

  @action
  onCopyApiExample() {
    this.analytics.track('objects', 'object_api_example_copied');
  }

  @action
  onCopyPageLink() {
    this.analytics.track('objects', 'object_guide_page_link_copied');
  }

  @action
  changeTab(tab: Guidetab) {
    this.activeTab = tab;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'objects.type.guide': ObjectsTypeGuideController;
  }
}
